import React from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import { StyledFormNavigationAgentStep } from "./styled";

export const FormNavigationAgentStep = ({ path, title, activeStep, extraClass }) => {
  return (
    <StyledFormNavigationAgentStep className={extraClass}>
      <Link to={path} className={cx("stepLink", activeStep && "activeLink")}>
        {title}
      </Link>
    </StyledFormNavigationAgentStep>
  );
};
